// -----------------------------------------------------------------------------
// Shared typography constants (extracted from LayoutControls to break the
// circular import between LayoutControls and TypographyPanel — see code
// review iter 47). Every consumer (LayoutControls, TypographyPanel,
// ResumePreview) imports the same lists from here.
// -----------------------------------------------------------------------------

// Open-source font families the user can pick from. `stack` is what actually
// gets applied via CSS; `label` is what the user sees. `family` is used as
// the <select> value (kept simple / URL-safe).
export const FONT_FAMILIES = [
  { family: "Inter",            label: "Inter",            stack: "'Inter', system-ui, -apple-system, sans-serif" },
  { family: "Roboto",           label: "Roboto",           stack: "'Roboto', Arial, sans-serif" },
  { family: "Lato",             label: "Lato",             stack: "'Lato', Arial, sans-serif" },
  { family: "Nunito Sans",      label: "Nunito Sans",      stack: "'Nunito Sans', Arial, sans-serif" },
  { family: "Manrope",          label: "Manrope",          stack: "'Manrope', system-ui, sans-serif" },
  { family: "Public Sans",      label: "Public Sans",      stack: "'Public Sans', system-ui, sans-serif" },
  { family: "Plus Jakarta Sans",label: "Plus Jakarta Sans",stack: "'Plus Jakarta Sans', system-ui, sans-serif" },
  { family: "Geist",            label: "Geist",            stack: "'Geist', 'Inter', system-ui, sans-serif" },
  { family: "JetBrains Mono",   label: "JetBrains Mono",   stack: "'JetBrains Mono', 'IBM Plex Mono', ui-monospace, monospace" },
  { family: "Arial",            label: "Arial",            stack: "Arial, Helvetica, sans-serif" },
];

// Header colour swatches. Description text is intentionally *not* configurable
// per product spec — it stays dark grey (#404040) for readability.
export const HEADER_COLORS = [
  { id: "black",     label: "Black",     value: "#0a0a0a" },
  { id: "white",     label: "White",     value: "#ffffff" },
  { id: "grey",      label: "Grey",      value: "#525252" },
  { id: "light-blue",label: "Light Blue",value: "#3B82F6" },
  { id: "green",     label: "Green",     value: "#16A34A" },
  { id: "orange",    label: "Orange",    value: "#EA580C" },
  { id: "dark-blue", label: "Dark Blue", value: "#1E3A8A" },
];

export const FONT_WEIGHTS = [
  { id: 100, label: "Thin · 100" },
  { id: 200, label: "Extra Light · 200" },
  { id: 300, label: "Light · 300" },
  { id: 400, label: "Regular · 400" },
  { id: 500, label: "Medium · 500" },
  { id: 600, label: "Semi Bold · 600" },
  { id: 700, label: "Bold · 700" },
  { id: 800, label: "Extra Bold · 800" },
  { id: 900, label: "Black · 900" },
];
